import moment from "moment-timezone";
import systemConfigService from '@/services/systemConfig';

export default {
    isNumber(event) {
        event = event ? event : window.event;
        var charCode = event.which ? event.which : event.keyCode;
        if (charCode >= 48 && charCode <= 57) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    },
    formatNumber(value, dicimal) {
        if (isNaN(parseFloat(value))) {
            return value;
        } else {
            if (value % 1 == 0) {
                return parseFloat(value).toLocaleString(undefined, {
                    minimumFractionDigits: dicimal,
                    maximumFractionDigits: dicimal
                });
            } else {
                let parts = value.toString().split(".");
                let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                let digit = parts[1].slice(0, 2);
                digit = digit.length < 2 ? digit + "0" : digit;
                return num + "." + digit;
            }
        }
    },
    formatDate(date, format) {
        return moment(date).format(format);
    },
    async getConfigValue(configKey, defaultValue = null) {
        try {
            const response = await systemConfigService.getConfigByKey(
                configKey
            );

            if (
                response.success &&
                response.data &&
                response.data.config_value !== undefined
            ) {
                let value = response.data.config_value;
                // แปลง boolean string
                if (value === 'true') {
                    return true;
                }
                if (value === 'false') {
                    return false;
                }
                return value;
            }
            return defaultValue;
        } catch (error) {
            console.error(
                'getConfigValue error:',
                configKey,
                error
            );
            return defaultValue;
        }
    },
    async getPublicConfigValue(configKey, defaultValue = null) {
        try {
            const response = await systemConfigService.getPublicConfigByKey(
                configKey
            );
            console.log('CONFIG RESPONSE:', response);

            if (
                response.success &&
                response.data &&
                response.data.config_value !== undefined
            ) {
                let value = response.data.config_value;
                // แปลง boolean string
                if (value === 'true') {
                    return true;
                }
                if (value === 'false') {
                    return false;
                }
                return value;
            }
            return defaultValue;
        } catch (error) {
            console.error(
                'getPublicConfigValue error:',
                configKey,
                error
            );
            return defaultValue;

        }

    }
}